import { parse } from "node-html-parser";
export const getBlockProps = (props: Record<any, any>): any =>
  Object.entries(props)
    .map(([key, value]) => [key, JSON.parse(decodeURIComponent(value))])
    .reduce(
      (prev, [key, value]) => ({
        ...prev,
        [key]: value,
      }),
      {}
    );

export const preprocessContent = (content: string) => {
  const dom = parse(content);

  const elems = Array.from(dom.querySelectorAll("pre[data-block-type]"));

  elems.forEach((elem: any) => {
    const type = elem.getAttribute("data-block-type");

    try {
      const blockData = elem.childNodes[0].text.replace(/^<code>/, "").replace(/<\/code>$/, "");
      const data = JSON.parse(blockData);
      const attrs = Object.entries(data).reduce(
        (prev, [key, value]) => prev + ` ${key}="${encodeURIComponent(JSON.stringify(value))}"`,
        ""
      );
      const div = parse(`<div data-block-type="${type}" ${attrs}></div>`);

      elem.replaceWith(div);
    } catch (err) {}
  });

  return dom.toString().trim();
};

export const flattenP = (html: string) => {
  const dom = parse(html);
  const paragraphs = Array.from(dom.querySelectorAll("p"));
  paragraphs.forEach((el) => {
    el.insertAdjacentHTML("beforebegin", el.innerHTML);
    el.remove();
  });

  return dom.toString();
};

export const flattenPToBR = (html: string) => {
  const dom = parse(html);
  const paragraphs = Array.from(dom.querySelectorAll("> p"));
  paragraphs.forEach((el, index) => {
    el.insertAdjacentHTML("beforebegin", el.innerHTML + (index < paragraphs.length - 1 ? "<br/>" : ""));
    el.remove();
  });

  return dom.toString();
};

export const formatList = (html: string) => {
  const dom = parse(html);
  const strongTags = Array.from(dom.querySelectorAll("li > strong"));
  strongTags.forEach((el, index) => {
    if (el.previousSibling?.toString()?.trim()) {
      el.classList.add("no-style");
    }
  });

  return dom.toString();
};

export const getOnlyElementsChildren = (val: Record<string, any>[]) =>
  val.filter(({ type }) => type === "element");
